import { Stack } from "@mui/material";
import { TechnicalConfigTabHeader } from "features/shared/components/technical-config-tab/TechnicalConfigTabHeader";
import { useState } from "react";

import type { LayeredConstructionApi } from "../api/createLayeredConstructionApi";
import type { ConstructionGroup } from "../model/types";
import type { LayeredConstructionVariant } from "../model/variants";

import { CatalogDrawer } from "./CatalogDrawer";
import { ConfigDrawer } from "./ConfigDrawer";
import { GroupTable } from "./GroupTable";

type LayeredConstructionTabProps = {
  api: LayeredConstructionApi;
  projectId: string;
  variant: LayeredConstructionVariant;
};

export const LayeredConstructionTab = ({ api, projectId, variant }: LayeredConstructionTabProps) => {
  const { data: rows = [], isLoading } = api.useGetGroups(projectId);
  const { mutate: deleteConfig } = api.useDeleteConfig();
  const [selectedGroup, setSelectedGroup] = useState<ConstructionGroup | null>(null);
  const [catalogOpen, setCatalogOpen] = useState(false);
  const i18nPrefix = `TechnicalData.${variant.i18nKey}`;

  const handleDelete = (group: ConstructionGroup) => {
    if (!group.hasTechnology) return;
    deleteConfig({ projectId, userDefinedType: group.userDefinedType }, { onSuccess: () => setSelectedGroup(null) });
  };

  return (
    <Stack className="w-full flex-col items-stretch gap-6">
      <TechnicalConfigTabHeader
        descriptionKey={`${i18nPrefix}.description`}
        manageCatalogKey={`${i18nPrefix}.manageTypePools`}
        onManageCatalog={() => setCatalogOpen(true)}
        titleKey={`${i18nPrefix}.title`}
      />
      <GroupTable
        groups={rows}
        isLoading={isLoading}
        onConfigure={setSelectedGroup}
        onDelete={handleDelete}
        variant={variant}
      />
      <ConfigDrawer
        api={api}
        group={selectedGroup}
        onClose={() => setSelectedGroup(null)}
        open={Boolean(selectedGroup)}
        projectId={projectId}
        variant={variant}
      />
      <CatalogDrawer api={api} onClose={() => setCatalogOpen(false)} open={catalogOpen} variant={variant} />
    </Stack>
  );
};
